import logger from './logger';

// animation.service.js
import axios from 'axios';
import authHeader from './auth-header';
// Dans le fichier où vous avez besoin de l'adresse IP
import config from './config';
import AuthService from './auth.service';

const API_URL = `${config.serverIP}/${config.apiVersion}`;


const getBadgeById = async (badgeId) => {
  try {
    const userId = AuthService.getUserId();
    const url = `${API_URL}/profils/users/${userId}/badges/${badgeId}`;
    const response = await axios.get(url,{ headers: authHeader() });
    logger.log('url  :', response.data);
    return response.data;
  } catch (error) {
    logger.log("Erreur lors de la récupération du badge:", error);
    throw error;
  }
};


const animationService = {
  getBadgeById,
};


  


export default animationService;
